{
  "pagination": {
    "ListMeshes": {
      "input_token": "nextToken",
      "limit_key": "limit",
      "output_token": "nextToken",
      "result_key": "meshes"
    },
    "ListRoutes": {
      "input_token": "nextToken",
      "limit_key": "limit",
      "output_token": "nextToken",
      "result_key": "routes"
    },
    "ListVirtualNodes": {
      "input_token": "nextToken",
      "limit_key": "limit",
      "output_token": "nextToken",
      "result_key": "virtualNodes"
    },
    "ListVirtualRouters": {
      "input_token": "nextToken",
      "limit_key": "limit",
      "output_token": "nextToken",
      "result_key": "virtualRouters"
    }
  }
}